// src/components/organisms/cart/errors/index.js

export { default } from './Errors'
